import "./App.css";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { ThemeContextProvider } from "./utils/ThemeContext";

// Stores
import { useStores } from "./use-stores";

// Layouts
import DefaultLayout from "./views/layout/DefaultLayout";

// Pages
import Login from "./views/pages/Login";
import { NotificationProvider } from "./utils/NotificationsContext";
import ForgetPassword from "./views/pages/ForgetPassword";
import ResetPasswordOtp from "./views/pages/ResetPasswordOtp";
import usePageTracking from "./analytics/pageTracking";
import GoogleSuccessPopup from "./views/pages/GoogleSuccessPopup";

function App() {
  usePageTracking();

  const { userStore } = useStores();
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  useEffect(() => {
    const tokenKey = process.env.REACT_APP_TOKEN_KEY!;
    const token = searchParams.get("token");
    if (token) {
      localStorage.setItem(tokenKey, token);
    }

    const storedToken = localStorage.getItem(tokenKey);
    if (!storedToken) {
      setLoading(false);
      return;
    }

    userStore
      .getUserDetails()
      .catch((_err) => console.log("LOGGED OUT"))
      .finally(() => setLoading(false));
  }, [userStore, searchParams.get("token")]);

  return (
    <ThemeContextProvider>
      <NotificationProvider>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Routes>
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route
              path="/change-password"
              element={<ResetPasswordOtp />}
            />
            <Route path="/google-auth/success" element={<GoogleSuccessPopup />} />
            {userStore.isLoggedIn ? (
              <>
                <Route path="*" element={<DefaultLayout />} />
              </>
            ) : (
              <>
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </>
            )}
          </Routes>
        )}
      </NotificationProvider>
    </ThemeContextProvider>
  );
}

export default observer(App);